import { decamelizeKeys } from 'humps'

import type { Address } from '~/types'

export const serializeAddress = (address: Address) => {
  return decamelizeKeys(address)
}
